export enum Visibility {
    Public = 0,
    Private = 1,
    Unlisted = 2,
}